import { ChatMessage } from '@twaice-fe/shared/models';
import { RuleActivity, RuleEvaluation } from '../../../component-sidebar.types';

export interface UiRuleState {
  backgroundColor: string;
  borderColor: string;
  stateLabel: string;
  stateIcon: string;
  stateIconColor: string;
  textColor: string;
}

export interface Transition {
  from: UiRuleEvaluation;
  to: UiRuleEvaluation;
  date: Date;
}

export interface TimeLineItem {
  date: Date;
  icon: string;
  message?: ChatMessage;
  transition?: Transition;
  activity?: RuleActivity;
}

export enum FilterOptions {
  ALL = 'ALL',
  TRANSITIONS = 'TRANSITIONS',
  CHAT = 'CHAT',
  ADDITIONAL = 'ADDITIONAL',
}

export type UiRuleEvaluation = RuleEvaluation & UiRuleState;
